import { IItem } from '../types';
import { ITableRowValue } from '../../components/TableRow';
import { listExceptions } from '../../services/listExceptions';

export const columns: ITableRowValue[] = [
  [
    'Parameter',
    'This is the name of the parameter where the item will appear in the "Create New Link" interface. Example: Parameter "Channel", Item "Display". A parameter usually is a dropdown where you can select an item, or a free text field where you can add text yourself.',
  ],
  [
    'Item',
    'This is the value that has been added to the tool in order to describe your campaigns. Example: "Display", "Social Media"; "Banner", "CPC", "Brand".',
  ],
  [
    'Item Visibility',
    'Select here if the Item should always be visible as a default or not. Example: Item "Display" should always be visible as a default.',
  ],
  [
    'Exception (Item)',
    'Add here any exception to the default visibility of each item before. Example: Item "Skyscraper" should only appear if beforehand item "Display" has been selected before.',
  ],
  [
    'Profile Visibility',
    'Select here if an item should always be visible or always be hidden as a default for all available profiles in the "Create New Links - Individual Links" interface.',
  ],
  [
    'Exception (Visibility)',
    'Select here if there are any exceptions to the visibility default you have selected for the profile(s) before (-> always visible / always hidden in profiles).',
  ],
];

export const getColumnValues = (item: IItem) => [
  `${item.parameter.name} (${item.parameter.id})`,
  `${item.name} (${item.id})`,
  item.defaultItems ? 'Visible' : 'Hidden',
  listExceptions(item.itemVisibilityConditions, 'itemSource'),
  item.defaultProfiles ? 'Visible' : 'Hidden',
  listExceptions(item.itemProfileVisibilityConditions, 'profile'),
];



// WEBPACK FOOTER //
// ./src/views/Admin/Items/services/columnData.ts